import styled from "styled-components";

const List = styled.ul`
  max-width: ${props => props.theme.paragraph.medium.maxWidth};
  padding-inline-start: 25px;
`;

export default List;
